import { PluginSlot } from '@openedx/frontend-plugin-framework';

const EditVideoAlertsSlot = () => <PluginSlot id="org.openedx.frontend.authoring.edit_video_alerts.v1" />;

export default EditVideoAlertsSlot;
